// extracted by mini-css-extract-plugin
export var searchHeader = "_78-0";
export var searchHeaderDark = "_78-1";